
import { useState, useEffect } from 'react';
import ReactPlayer from 'react-player';

const HeroSection = () => {
  const defaultUTM =
  "?utm_source=online&utm_medium=website&utm_campaign=website_lead&utm_term=landing_page";

const [utmParams, setUtmParams] = useState<string>(() => {
  // Try to get from localStorage on initial load (e.g. second visit)
  return localStorage.getItem('utm_params') || defaultUTM;
});

useEffect(() => {
  const queryString = window.location.search;
  if (queryString && queryString.includes('utm_')) {
    localStorage.setItem('utm_params', queryString);
    setUtmParams(queryString); // Triggers rerender
  }
}, []);

const signupLink = `https://app.eximpe.com/auth/sign-up${utmParams}`;


  return (
    <section className="pt- pb-16 bg-gradient-to-b lg:px-[13%] from-white to-gray-50 relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute top-20 left-10 w-64 h-64 bg-[#1c9e86]/5 rounded-full blur-3xl -z-10"></div>
      <div className="absolute bottom-20 right-10 w-80 h-80 bg-[#1c9e86]/10 rounded-full blur-3xl -z-10"></div>

      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center">
          {/* Left side - Text content */}
          <div className="w-full md:w-1/2 mb-12 md:mb-0">
            <h1 className="text-3xl text-center md:text-left sm:text-4xl md:text-5xl lg:text-5xl font-bold text-gray-800 mb-6 leading-tight">
              Get Global Virtual Bank Account <span className="text-[#1c9e86]">Within 24 Hours</span>
            </h1>
            <p className="text-lg text-center md:text-left sm:text-xl md:text-2xl text-[#4b5563] mb-8 leading-relaxed">
              Accept local payments with Instant e-FIRA generation for your international business
            </p>

            {/* Partners section */}
            

            {/* CTA Button */}
            <div className="flex flex-col sm:flex-row gap-4 items-center">
              <a href={signupLink}>
                <button className="w-full hover:cursor-pointer sm:w-auto bg-[#1c9e86] hover:bg-[#168a75] text-white font-bold py-4 px-8 rounded-lg transition duration-300 shadow-xl hover:shadow-2xl transform hover:-translate-y-1 text-lg">
                  Sign Up Now
                </button>
              </a>
            </div>
          </div>

          {/* Right side - Video inside phone mockup */}
          <div className="w-full md:block md:w-1/2 flex justify-center lg:pl-50 md:pl-20 md:justify-end relative">
            <div className="relative w-[400px] h-[700px] bg-[#0d1120] rounded-[2.5rem] border-[6px] border-[#51af91] shadow-xl flex items-center justify-center overflow-hidden">
              
              <ReactPlayer
                url="/review.mp4"
                playing={true}
                controls={true}
                autoplay={true}
                loop={true}
                width="100%"
                height="100%"
                style={{
                  borderRadius: '2.5rem',
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
